import { observer } from 'mobx-react-lite'
import { AssignNumberCommon } from 'entities/Phone'
import { useBuyNumberStepsContext } from 'pages/settings/pages/numbers/pages/BuyNumber/context/useBuyNumberStepsContext'

export const AssignNumber = observer(() => {
  const { assignNumberStore, confirmNumber, numbersLayerStore, isBuyNumberAction } =
    useBuyNumberStepsContext()

  return (
    <AssignNumberCommon
      store={assignNumberStore}
      nextButtonProps={
        isBuyNumberAction
          ? {
              text: 'Buy number',
              onClick: confirmNumber,
              loading: numbersLayerStore.stepsStore.stepLoading,
            }
          : undefined
      }
    />
  )
})
